import http from './http'

export default {
  availableForEvent: params => http.get('/v2/judges/available-for-event', { params }),
  // Cursor-paginated picker (CAM-1477 follow-up) — EventAddDetails.vue's search-select.
  options: params => http.get('/v2/judges/options', { params })
}



// WEBPACK FOOTER //
// ./src/services/api/judges.js